import styled from "styled-components";

export const Container = styled.form`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  width: 100%;
  > * {
    width: 100%;
    &.half {
      width: 48%;
    }
    &.third {
      width: 32%;
    }
    &.quarter {
      width: 24%;
    }

    margin-top: 5rem;
  }

  :first-child {
    margin: 0;
  }
`;

export const ErrorMesageContainer = styled.label`
  font-size: 2.4rem;
  color: ${(props) => props.theme.colors.RED};
  padding-top: 1rem;
`;

export const TextFieldContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  label {
    margin-right: 3rem;
    font-size: 3.4rem;
    text-align: left;
    direction: ltr;
    font-weight: 800;
    color: ${(props) => props.theme.colors.GREY_5};
  }
`;

export const FieldContainer = styled.div`
  .subtitle {
    margin-bottom: 2rem;
    font-size: 3rem;
  }
`;
